import { NotFoundError } from "@repo/ui/components/not-found-error";

export default function Page() {
  return (
    <div className="flex h-dvh w-full items-center justify-center">
      <NotFoundError message="" />
    </div>
  );
}
